<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>William C. Young is an alternative history and sci-fi buff who decided to put his passion onto paper. He lives in a quiet corner of Perth, Western Australia, and enjoys the many bounties of this great country.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?37fd5dfc